import awsdk from 'awsdk';

// MALE
// FEMALE

export const Gender = awsdk.AWSDKGender;
export type Gender = typeof Gender;
